import React from 'react';
import EnvironmentManager from 'Utils/environmentManager';
import PropTypes from 'prop-types';
import Icon from '../../Icon';
const ErrorMessage = ({ verifyData, isValid, selectedBetId }) => {
  const getMessage = ()=> {
    const errorText = EnvironmentManager.getMessageText({ key: 'description_tjk_betslip_' + selectedBetId }) || 'Lütfen her yarışa en az bir at ekleyiniz.';

    let errorMessage = EnvironmentManager.getMessageText({ key: verifyData?.error?.domain + verifyData?.error?.code }) || verifyData?.error?.message;

    if (verifyData?.error?.domain === 'tjk-mobile-bff' && verifyData?.error?.code === 1001) {
      errorMessage = EnvironmentManager.getMessageText({ key: 'description_tjk_betslip_' + selectedBetId });
    }
    if (verifyData?.error?.domain === 'tjk-mobile-bff' && verifyData?.error?.code === 1002) {
      const maxPrice = +EnvironmentManager.getMessageText({ key: 'tjkapp_tjk_max_coupon_total' }) || 6500;
      errorMessage = EnvironmentManager.getMessageText({ key: verifyData?.error?.domain + verifyData?.error?.code }).replace('%@', maxPrice);
    }
    if (verifyData?.error?.domain === 'tjk-mobile-bff' && verifyData?.error?.code === 1003) {
      const minPrice = +EnvironmentManager.getMessageText({ key: 'tjkapp_tjk_min_coupon_total' }) || 10;
      errorMessage = EnvironmentManager.getMessageText({ key: verifyData?.error?.domain + verifyData?.error?.code }).replace('%@', minPrice);
    }

    return !isValid ? errorText : errorMessage || 'Kupon kontrol edilirken bir hata oluştu.';
  };
  return (!isValid || verifyData?.error) && verifyData?.error?.code !== 1018 && <div className="error">
    <Icon iconName="svgInfoWhite"/>
    <p>{ getMessage() }</p>
  </div>;
};

ErrorMessage.propTypes = {
  isValid: PropTypes.bool.isRequired,
  verifyData: PropTypes.object,
  selectedBetId: PropTypes.string.isRequired
};

export default ErrorMessage;
